<div
  [hidden]="userPreferencesLoading"
  class="community-selector"
  [ngClass]="{ expanded: expanded }"
>
  <!-- Header -->
  @if (!smallScreen) {
    <div
      class="header p-3"
      (mouseenter)="shouldScrollCommunitySpaces = true"
      (mouseleave)="shouldScrollCommunitySpaces = false"
    >
      <div
        class="d-flex align-items-center"
        [ngClass]="{
          'justify-content-center': !expanded,
          'justify-content-between': expanded,
        }"
      >
        @if (!isDropdownMode()) {
          <button
            class="d-flex align-items-center pointer-cursor text-medium-gray btn-unstyled"
            (click)="toggleCollapse()"
          >
            <ng-icon
              [name]="expanded ? 'matChevronLeft' : 'matChevronRight'"
            ></ng-icon>

            @if (expanded) {
              <span
                class="font-size-sm ms-2"
                translate
              >
                Sidebar.Minimize
              </span>
            }
          </button>

          @if (expanded) {
            <div
              appTooltip
              class="ms-2 d-flex align-items-center"
              triggers="click"
              placement="right"
              [ngbTooltip]="
                'Sidebar.Helptext'
                  | translate
                  | stringReplacement
                    : { '{tenantName}': sessionService.tenant?.name }
              "
              tooltipClass="sidebar-helptext-tooltip"
              #t="ngbTooltip"
              [toolTipControl]="t"
              container="body"
            >
              <ng-icon
                name="matInfo"
                class="tooltip-icon align-middle pointer-cursor"
              ></ng-icon>
            </div>
          }
        }
      </div>

      @if (expanded) {
        <span
          class="d-block font-size-xl fw-bold mt-3"
          translate
        >
          Sidebar.CommunitySpaces
        </span>
      }
    </div>
  }

  <div
    #mainContent
    class="main-content"
    cdkScrollable
  >
    <!-- General Section -->
    <div class="general">
      <button
        class="d-flex align-items-center community-item px-3 py-2 btn-unstyled"
        [ngClass]="{
          'active fw-bold': !organizationId,
        }"
        (click)="onClickItem('box-all-innovation'); orgSelected.emit()"
      >
        <input
          (change)="selectAll(organizationId, $event)"
          [(ngModel)]="allInnovation"
          id="box-all-innovation"
          type="checkbox"
          class="d-none"
        />

        <ng-container *ngTemplateOutlet="tenantLogoTemplate"> </ng-container>

        @if (expanded) {
          <ng-container
            *ngTemplateOutlet="
              labelTemplate;
              context: { label: 'Sidebar.AllContent' }
            "
          ></ng-container>
        }
      </button>
    </div>

    <!-- Favorite Section -->
    @if (orgFilterList) {
      <div class="favorite">
        @if (expanded) {
          <div
            class="d-flex align-items-center justify-content-between mt-3 text-medium-gray px-3"
          >
            <button
              class="d-flex align-items-center pointer-cursor text-medium-gray fw-bold btn-unstyled"
              (click)="toggleFavoriteSection()"
              translate
            >
              <ng-icon
                [name]="
                  favoriteOpened
                    ? 'matArrowDropDownOutline'
                    : 'matArrowDropUpOutline'
                "
                size="1.25rem"
                class="me-1"
              ></ng-icon>

              Sidebar.MySpaces
            </button>

            <div class="actions d-flex align-items-center">
              <button
                class="pointer-cursor open-favorite-btn btn-unstyled"
                [class.disabled]="orderModeActivated"
                (click)="openAddFavoriteDialog()"
              >
                <ng-icon name="matAddCircleOutline"></ng-icon>
              </button>

              @if (true) {
                <div
                  ngbDropdown
                  container="body"
                  class="dropdown-no-arrow"
                >
                  <span
                    class="pointer-cursor more-actions-btn"
                    [class.disabled]="orderModeActivated"
                    ngbDropdownToggle
                  >
                    <ng-icon name="matMoreHorizOutline"></ng-icon>
                  </span>

                  <ul
                    class="actions-dropdown-menu"
                    ngbDropdownMenu
                  >
                    <li
                      ngbDropdownItem
                      class="pointer-cursor"
                    >
                      <button
                        class="btn-unstyled d-flex align-items-center"
                        (click)="orderModeActivated = true"
                      >
                        <ng-icon
                          name="matReorderOutline"
                          class="me-2 font-size-sm"
                        ></ng-icon>
                        <span translate>Sidebar.OrderMySpaces</span>
                      </button>
                    </li>
                  </ul>
                </div>
              }
            </div>
          </div>

          @if (orderModeActivated) {
            <span class="font-size-sm px-3 py-2 text-medium-gray d-block"
              >You can drag and drop to order the position of communities
              list.</span
            >
          }
        }

        @if (!expanded && favoriteOpened) {
          <ng-container
            *ngTemplateOutlet="divider; context: { orgList: orgFilterList }"
          ></ng-container>
        }

        @if (favoriteOpened) {
          @if (orgFilterList?.length > 0) {
            @if (orderModeActivated || !smallScreen) {
              <div
                cdkDropList
                [cdkDropListDisabled]="!this.orderModeActivated"
                (cdkDropListDropped)="onDrop($event)"
              >
                @for (item of removeDuplicates(orgFilterList); track item.id) {
                  @if (item | call: shouldShowFilterToken) {
                    <button
                      cdkDrag
                      [cdkDragData]="item"
                      (click)="onOrganizationItemClick(item)"
                      class="d-flex align-items-center community-item px-3 py-2 position-relative pointer-cursor btn-unstyled"
                      [ngClass]="{
                        'active fw-bold':
                          item.id === organizationId && !orderModeActivated,
                      }"
                    >
                      <ng-container
                        *ngTemplateOutlet="orgTemplate; context: { item: item }"
                      ></ng-container>

                      @if (orderModeActivated) {
                        <div
                          *cdkDragPreview
                          class="org-drag-preview"
                        >
                          <app-organization-logo
                            class="org-logo d-block"
                            [organizationLogo]="item.imgUrl"
                            [alt]="item.name"
                          ></app-organization-logo>
                        </div>

                        <div class="position-indicator">
                          <div class="circle-start"></div>
                          <div class="line"></div>
                          <div class="circle-end"></div>
                        </div>
                      }
                      @if (orderModeActivated) {
                        <div
                          *cdkDragPreview
                          class="org-drag-preview"
                        >
                          <app-organization-logo
                            class="org-logo d-block"
                            [organizationLogo]="item.imgUrl"
                            [alt]="item.name"
                          ></app-organization-logo>
                        </div>

                        <div class="position-indicator">
                          <div class="circle-start"></div>
                          <div class="line"></div>
                          <div class="circle-end"></div>
                        </div>
                      }
                    </button>
                  }
                }
              </div>
            } @else {
              @for (item of removeDuplicates(orgFilterList); track item.id) {
                @if (item | call: shouldShowFilterToken) {
                  <button
                    #swipeableOrgItem
                    [id]="item.id"
                    (click)="onOrganizationItemClick(item)"
                    class="d-flex align-items-center community-item px-3 py-2 position-relative swipe-item btn-unstyled"
                    [ngClass]="{
                      'active fw-bold':
                        item.id === organizationId && !orderModeActivated,
                    }"
                  >
                    <ng-container
                      *ngTemplateOutlet="orgTemplate; context: { item: item }"
                    ></ng-container>
                  </button>
                }
              }
            }
          } @else {
            @if (expanded) {
              <p
                class="mt-3 px-3"
                [innerHTML]="
                  'Sidebar.AddToFavoritesGuide'
                    | translate
                    | stringReplacement
                      : {
                          '{searchForAndAddText}':
                            null
                            | linkWrapper
                              : ('Sidebar.SearchForAndAdd' | translate),
                        }
                "
              ></p>
            }
          }
        }

        @if (orderModeActivated) {
          <div class="d-flex px-3 py-2">
            <button
              type="button"
              class="btn btn-outline-secondary py-1 font-size-sm flex-1 me-1"
              (click)="cancelOrderMode()"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-primary py-1 font-size-sm flex-1"
              [disabled]="savingOrgOrder"
              (click)="onSaveOrgOrder()"
            >
              @if (savingOrgOrder) {
                <span
                  class="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
              }
              Save
            </button>
          </div>
        }
      </div>
    }

    <!-- Popular Section -->
    <div class="popular pb-3">
      @if (expanded) {
        <button
          class="d-flex align-items-center pointer-cursor mt-3 text-medium-gray px-3 fw-bold btn-unstyled"
          (click)="togglePopularSection()"
          translate
        >
          <ng-icon
            [name]="
              popularOpened
                ? 'matArrowDropDownOutline'
                : 'matArrowDropUpOutline'
            "
            size="1.25rem"
            class="me-1"
          ></ng-icon>

          Sidebar.Popular
        </button>
      }

      @if (!expanded) {
        <ng-container
          *ngTemplateOutlet="divider; context: { orgList: popularOrgs }"
        ></ng-container>
      }

      @if (popularOpened) {
        @for (item of popularOrgs; track item.id) {
          <button
            class="d-flex align-items-center community-item px-3 py-2 btn-unstyled"
            (click)="selectOrganization(item)"
            [ngClass]="{
              'active fw-bold': item.id === organizationId,
            }"
          >
            <input
              (click)="
                organizationId !== item.id && filterOrganizations(item.id)
              "
              (keydown.space)="
                organizationId !== item.id && filterOrganizations(item.id)
              "
              [id]="'box-org-' + item.id"
              [ngModel]="organizationId === item.id"
              type="checkbox"
              class="d-none"
            />

            <app-organization-logo
              class="org-logo flex-shrink-0"
              [organizationLogo]="item.logo.url"
              [showCopyText]="false"
              [redirectEnabled]="false"
            ></app-organization-logo>

            @if (expanded) {
              <div class="ms-2 pointer-cursor overflow-hidden">
                <span
                  #popularNameTip="ngbTooltip"
                  class="flex-1 truncate-line-1 d-block font-size-sm pointer-cursor text-truncate"
                  [ngbTooltip]="item.orgName"
                  container="body"
                  [disableTooltip]="smallScreen || hasTouchInput"
                  (click)="popularNameTip.close(false)"
                  (keydown.escape)="popularNameTip.close(false)"
                >
                  {{ item.orgName }}
                </span>

                @if (shouldShowAddToFavorite(item)) {
                  <div
                    appDebounceClick
                    (debounceClick)="handleAddOrgToFavorite(item.id, false)"
                    class="add-to-favorite"
                  >
                    <ng-icon name="matAddCircleOutline"></ng-icon>
                    <span
                      class="ms-1"
                      translate
                      >Common.AddToSpaces</span
                    >
                  </div>
                }
              </div>
            }
          </button>
        }
      }
    </div>
  </div>
</div>

<ng-template #tenantLogoTemplate>
  <app-organization-logo
    class="org-logo"
    [organizationLogo]="
      sessionService.tenant?.icon?.url || sessionService.tenant?.logo?.url
    "
    [showCopyText]="false"
    [redirectEnabled]="false"
  ></app-organization-logo>
</ng-template>

<ng-template
  #labelTemplate
  let-label="label"
>
  <span
    translate
    class="flex-1 truncate-line-1 d-inline-block font-size-sm pointer-cursor ms-2"
  >
    {{ label }}
  </span>
</ng-template>

<!-- Modal -->
<ng-template
  #modalRef
  let-modal
>
  <div class="modal-header">
    <h4
      class="modal-title"
      translate
    >
      Common.AddToSpaces
    </h4>

    <button
      (click)="modal.close()"
      aria-describedby="modal-title"
      aria-label="Close"
      class="btn-close close font-size-2xl"
      type="button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div
    class="modal-body"
    style="height: 500px"
  >
    <app-organisation-search
      #organizationSearch
      [searchMode]="orgsSearchMode.ForSubmittingAll"
      [searchPlaceholder]="'Search and add' | translate"
      [enableDynamicHeight]="false"
      [height]="420"
      [autoOpenDropdown]="true"
      [closeDropdownOnSelect]="false"
      [excludedOrganisationIds]="ignoreOrgIds"
      [updateListOnSelect]="true"
      [considerInnovationSpace]="false"
      (selectOrganisation)="selectItem($event)"
    ></app-organisation-search>
  </div>
</ng-template>

<!-- Divider -->
<ng-template
  #divider
  let-orgList="orgList"
>
  @if (orgList.length) {
    <div class="divider mx-3 my-2"></div>
  }
</ng-template>

<ng-template
  #orgTemplate
  let-item="item"
>
  <input
    (click)="organizationId !== item.id && filterOrganizations(item.id)"
    (keydown.space)="organizationId !== item.id && filterOrganizations(item.id)"
    [id]="'box-org-' + item.id"
    [ngModel]="organizationId === item.id"
    type="checkbox"
    class="d-none"
  />

  @if (orderModeActivated) {
    <ng-icon
      name="matDragIndicatorOutline"
      class="me-2 pointer-cursor text-medium-gray"
    ></ng-icon>
  }

  <div class="logo-container">
    <app-organization-logo
      class="org-logo d-block"
      [organizationLogo]="item.imgUrl"
      [showCopyText]="false"
      [alt]="item.name"
      [redirectEnabled]="false"
    ></app-organization-logo>

    @if (!smallScreen) {
      <button
        #removeTip="ngbTooltip"
        [ngbTooltip]="'Remove'"
        placement="top"
        container="body"
        [disableTooltip]="smallScreen || hasTouchInput || orderModeActivated"
        class="delete-icon position-absolute btn-unstyled"
        [class.d-none]="orderModeActivated"
        (click)="
          $event.stopPropagation(); removeTip.close(false); removeItem(item)
        "
      >
        <span>×</span>
      </button>
    }
  </div>

  @if (expanded) {
    <div class="flex-1">
      <span
        #nameTip="ngbTooltip"
        class="truncate-line-1 font-size-sm pointer-cursor ms-2"
        [ngbTooltip]="item.name"
        container="body"
        [disableTooltip]="smallScreen || hasTouchInput || orderModeActivated"
        [style.width]="'fit-content'"
        (click)="nameTip.close(false)"
        (keydown.escape)="nameTip.close(false)"
      >
        {{ item.name }}
      </span>
    </div>
  }

  @if (smallScreen && !this.orderModeActivated) {
    <div class="mobile-delete-btn">
      <button
        class="btn-unstyled"
        (click)="removeItem(item); $event.stopPropagation()"
      >
        <span class="font-size-2xl text-white">×</span>
      </button>
    </div>
  }
</ng-template>
